import React from "react";

const ActiveContext = React.createContext({});

export default ActiveContext;